/**
 * Labels are stored as a JSONB array on identities, but the reporting views
 * expose them as text. Accept every shape we have seen and return a clean list.
 */
export function parseLabels(value: unknown): string[] {
  if (!value) return [];
  let list: unknown[] = [];
  if (Array.isArray(value)) {
    list = value;
  } else if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        list = Array.isArray(parsed) ? parsed : [];
      } catch {
        list = trimmed.replace(/^\[|\]$/g, '').split(',');
      }
    } else if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
      // Postgres text[] literal: {a,b}
      list = trimmed.slice(1, -1).split(',');
    } else {
      list = trimmed.split(',');
    }
  }
  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of list) {
    const label = String(item ?? '')
      .replace(/^"+|"+$/g, '')
      .trim();
    if (label && !seen.has(label.toLowerCase())) {
      seen.add(label.toLowerCase());
      out.push(label);
    }
  }
  return out;
}

export const SUGGESTED_LABELS = ['Lead', 'Customer', 'Follow up', 'Important', 'Not interested', 'Spam'];

const TONES = [
  'bg-category-green-soft text-category-green ring-category-green/20',
  'bg-category-blue-soft text-category-blue ring-category-blue/20',
  'bg-category-purple-soft text-category-purple ring-category-purple/20',
  'bg-category-amber-soft text-category-amber ring-category-amber/20',
  'bg-category-rose-soft text-category-rose ring-category-rose/20',
  'bg-category-teal-soft text-category-teal ring-category-teal/20',
  'bg-category-indigo-soft text-category-indigo ring-category-indigo/20',
];

/** A label keeps the same color everywhere, whatever else is on screen. */
export function labelTone(label: string): string {
  let hash = 0;
  for (const ch of label.toLowerCase()) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return TONES[hash % TONES.length];
}
